export const wishlistButtonStyles = {
  root: 'text-brand-red hover:bg-brand-red/10 focus-visible:ring-brand-red/40 relative inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-md transition-colors duration-fast ease-token focus-visible:outline-none focus-visible:ring-2',
  icon: 'h-5 w-5',
  badge:
    'pointer-events-none absolute -right-0.5 -top-0.5 z-10 inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-accent px-1 text-[10px] font-bold leading-none text-accent-fg ring-2 ring-bg-canvas shadow-sm',
} as const;
